import user from './user';
import config from './config';
import createApi from './create';

export default createApi({
  user,
  config,
});
